import React from "react";

function Footer() {
  return (
    <div className="bg-black text-white p-y-20">
      <div className="container flex flex-col a-i-center j-c-center gap-10 fs-12">
        <p>For more information</p>
        <p>
          Email: <a href="mailto:admin@miip.com.my">admin@miip.com.my</a>
        </p>
        <p>
          Whatsapp:{" "}
          <a
            href="https://api.whatsapp.com/send?phone=60193467864"
            target="_blank"
            rel="noopener noreferrer"
          >
            +6019 3467864
          </a>
        </p>
      </div>
    </div>
  );
}

export default Footer;
